<template>
  <div class="footer">
    <div class="footer-container">
      <!-- Sol Taraf -->
      <div class="footer-left">
        <p>
          &copy; {{ currentYear }} Yusuf Eren Çatakkaya Tarafından
          desteklenmektedir.
        </p>
      </div>

      <!-- Orta Kısım -->
      <div class="footer-center">
        <h2>Sayfalar</h2>
        <div class="footer-menu">
          <ul>
            <router-link to="/"><li>Ana Sayfa</li></router-link>
            <router-link to="/projeler"><li>Projeler</li></router-link>
            <router-link to="/iletisim"><li>İletişim</li></router-link>
          </ul>
        </div>
      </div>

      <!-- Sağ Taraf -->
      <div class="footer-right">
        <h2>İletişim</h2>
        <div>
          <h3>Adres</h3>
          <p>
            Cemil Meriç, Ayabakan Sokağı 3 34771 <br />
            Dudullu Osb/Ümraniye/İstanbul
          </p>
        </div>
        <div>
          <h3>Bize Ulaşın</h3>
          <p>+90 542-223-39-96 (Mustafa Çatakkaya)</p>
          <p>+90 530-465-59-26 (Mustafa Gürçay)</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterViews",
  data() {
    return {
      currentYear: new Date().getFullYear(), // Dinamik yıl
    };
  },
};
</script>
<style>
.footer {
  background-color: #212529; /* Koyu bir arka plan */
  color: #f8f9fa; /* Kontrast metin rengi */
  padding: 40px 20px;
  font-family: Arial, sans-serif;
}

.footer-container {
  display: flex;
  flex-wrap: wrap; /* Mobil uyumluluk için sarma */
  justify-content: space-between;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto; /* Ortalamak için */
}

.footer-left,
.footer-center,
.footer-right {
  flex: 1;
  min-width: 250px; /* Kolonların daralmasını önleme */
}

.footer-left p {
  color: #adb5bd;
}

.footer-center {
  text-align: center;
}
.footer-center h2 {
  color: orange;
}

.footer-menu ul {
  list-style: none;
  padding: 0;
}

.footer-menu li {
  margin: 10px 0;
}

.footer-menu a {
  text-decoration: none;
  color: #f8f9fa;
  font-weight: bold;
  font-size: 18px;
  transition: color 0.3s ease;
}

.footer-menu a:hover {
  color: orange; /* Sarı hover rengi */
}

.footer-right h2 {
  color: orange; /* Sarı başlık */
}

.footer-right h3 {
  font-size: 18px;
  margin: 10px 0 5px;
}

.footer-right p {
  margin: 5px;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column; /* Küçük ekranlarda alt alta */
    text-align: center;
  }

  .footer-left,
  .footer-center,
  .footer-right {
    text-align: center;
  }
}
</style>
